export default "__VITE_ASSET__CUYwOnCi__"